import { createWeightColumnDefinition } from './weight-column-helper';
import { messages } from '../messages';

export const createWeightBufferColumnDefinition = createWeightColumnDefinition({
  accessor: 'weightBuffer',
  headerMessage: messages.weightBufferColumnHeader,
});
